var base = require('navbar/navbar');

Vue.component('spark-navbar', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/navbar/navbar.js